import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Link } from '@blocket/blocket-ui'
import { reopenCookieConsentModal } from 'utils/vendCookieConsent'

const CookieLink = styled.p`
  cursor: pointer;
`

const className = 'menu-section'

const MenuSection = ({ menuSection, trackFooterNavigation, isAppRoute }) => {
  const targetBlankUrls = [
    'Administrera butiksannonser',
    'Inloggning för butiker',
    'Cookies',
    'Personuppgiftshantering',
  ]

  const target = (menuItem) => {
    const useTargetBlank = targetBlankUrls.find((targetUrl) => menuItem.title === targetUrl)
    if (useTargetBlank) {
      return '_blank'
    }
    return '_self'
  }

  const clickCookieConsent = () => {
    reopenCookieConsentModal()
  }

  return (
    <div data-menu-section-id={menuSection.sys.id} className={className}>
      <h4 className={`${className}__title`}>
        <Link
          external={!isAppRoute(menuSection.url)}
          tabIndex="0"
          className={`${className}__title-link`}
          href={menuSection.url || '#'}
          onClick={(e) => trackFooterNavigation(e, menuSection.title)}
        >
          <span>{menuSection.title}</span>
        </Link>
      </h4>
      <ul className={`${className}__content`}>
        {menuSection.contentCollection &&
          menuSection.contentCollection.items.map((menuItem) => {
            return (
              <li className={`${className}__list-item`} key={menuItem.sys.id}>
                <Link
                  target={target(menuItem)}
                  rel="noopener noreferrer"
                  external={!isAppRoute(menuItem.url)}
                  className={`${className}__list-item-link`}
                  href={menuItem.url || '#'}
                  onClick={(e) => trackFooterNavigation(e, menuItem.title)}
                >
                  <span>{menuItem.title}</span>
                </Link>
              </li>
            )
          })}
        {menuSection.title === 'Villkor' && (
          <li className={`${className}__list-item`}>
            <CookieLink className={`${className}__list-item-link`} onClick={clickCookieConsent}>
              <span>Cookieinställningar</span>
            </CookieLink>
          </li>
        )}
      </ul>
    </div>
  )
}

MenuSection.propTypes = {
  menuSection: PropTypes.object,
  isAppRoute: PropTypes.func,
  trackFooterNavigation: PropTypes.func,
}
MenuSection.defaultProps = {}

export default MenuSection
